import { FC } from 'react';
import { CalendarDays, MapPin } from 'lucide-react';

import styles from './PunchupEventSummaryTile.module.css';

export interface PunchupEventSummaryTileProps {
	/** Show / event name — the prominent line. */
	title: string;
	/** Pre-formatted date (+ time) string, e.g. "Sat, Jun 14 · 8:00 PM". Omitted → the date row is hidden. */
	dateLabel?: string;
	/** Venue or street address. Omitted → the location row is hidden. */
	location?: string;
}

/**
 * The show-context summary tile shown at the top of a Punchup form page (Send Tickets, Scan Tickets): the show
 * name with a date row and a location row. Pure presentational — the caller formats `dateLabel`/`location` from
 * its own event-data shape (this component owns no event/domain knowledge), so it reads identically wherever an
 * event header is needed.
 */
export const PunchupEventSummaryTile: FC<PunchupEventSummaryTileProps> = ({ title, dateLabel, location }) => (
	<div className={styles.root}>
		<p className={styles.title}>{title}</p>
		{dateLabel && (
			<p className={styles.meta}>
				<CalendarDays size={14} aria-hidden />
				{dateLabel}
			</p>
		)}
		{location && (
			<p className={styles.meta}>
				<MapPin size={14} aria-hidden />
				{location}
			</p>
		)}
	</div>
);
